// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__12D-7","inputWrap":"styles_inputWrap__1iEMp","input":"styles_input__2lAZJ"};